var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEyesOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#343A40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.939 6c3.886 0 6.572 1.846 8.061 5.538l-.127.304c-1.512 3.49-4.156 5.235-7.934 5.235-3.777 0-6.384-1.745-7.819-5.235L4 11.538C5.407 7.846 8.054 6 11.939 6M12 8c-1.934 0-3.5 1.567-3.5 3.5S10.066 15 12 15c1.933 0 3.5-1.567 3.5-3.5S13.933 8 12 8m0 1.692c1.019 0 1.846.827 1.846 1.846 0 1.02-.827 1.847-1.846 1.847-1.02 0-1.847-.827-1.847-1.847 0-1.019.827-1.846 1.847-1.846",
    transform: "translate(-304 -240) translate(304 240)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyesOn);
export default __webpack_public_path__ + "static/media/ic_eyes_on.1127be4fbae8e3753d78f1e872279a74.svg";
export { ForwardRef as ReactComponent };